import {customElement, bindable, bindingMode} from 'aurelia-framework';
import * as _ from 'lodash';

@customElement('header-button')
export class HeaderButton {

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) click = _.noop;

  @bindable({
    defaultBindingMode: bindingMode.oneWay
  }) selected = false;

}
